/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationList } from '../../models/organization-list';

export interface GetAllMyOrganizations$Params {
}

export function getAllMyOrganizations(http: HttpClient, rootUrl: string, params?: GetAllMyOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationList>> {
  const rb = new RequestBuilder(rootUrl, getAllMyOrganizations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationList>;
    })
  );
}

getAllMyOrganizations.PATH = '/api/v1/mine';
